<template>
  <b-modal
    :title="modalTitle"
    id="modal-item-delete"
    centered
    ok-title="حذف"
    ok-variant="danger"
    cancel-title="انصراف"
    @cancel="closeModal"
    @ok.prevent="sendDeleteConfirmation"
  >
    <span>آیا از حذف {{ typeEnums[offerType] }} اطمینان دارید؟</span>
  </b-modal>
</template>

<script>
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
export default {
  emits: ["closeModal", "deleteCoupon", "deleteDiscount"],
  props: {
    offerType: {
      type: Number,
      required: true,
      validator: (val) =>
        [
          1, // discount
          2, // coupon
        ].includes(val),
    },
  },
  data() {
    return {
      typeEnums: {
        1: "کاهش قیمت",
        2: "کد تخفیف",
      },
    };
  },
  methods: {
    sendDeleteConfirmation() {
      if (this.offerType == 1) {
        this.$emit("deleteDiscount");
      } else {
        this.$emit("deleteCoupon");
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  computed: {
    modalTitle() {
      return `حذف ${this.typeEnums[this.offerType]}`;
    },
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
};
</script>
